import {GraphQLError} from 'graphql/error';

/**
 * Marks all fields as required and normalizes `undefined` to `null`
 */
export const normalizeGraphQLObject = <T extends Record<string, any>>(object: T): Required<T> => {
	return Object.keys(object).reduce((result, key) => {
		if (key.startsWith('__')) {
			return result;
		}

		return {
			...result,
			[key]: object[key] ?? null,
		};
	}, {}) as any;
};

export const logAndThrowGraphQLErrors = (errors: readonly GraphQLError[]): never => {
	if (errors.length === 1) {
		console.error(errors[0]);

		throw errors[0];
	} else {
		errors.forEach((error) => console.error(error));

		throw new Error('Multiple GraphQL errors encountered. See logs.');
	}
};
